export default {
  single_apartment: {
    id: null,
    badge: [],
    title: '',
    apartment_type: '',
    planning: null,
    street: '',
    number: '',
    premises_decoration: '',
    home_material: '',
    construction_stage: null,
    quarter: null,
    construction_type: [],
    year: '',
    sale_office: null,
    cadastral_number: '',
    rc_object: {
      id: null,
      title: '',
    },
    flat_count: '',
  },
  apartments: [],
  checkerboard_layout: [],
  flat_plannings_by_apartment: [],
  rooms_count_by_apartment: [
    {
      text: '1',
      value: 1,
    },
    {
      text: '2',
      value: 2,
    },
    {
      text: '3',
      value: 3,
    },
    {
      text: '4',
      value: 4,
    },
    {
      text: '5',
      value: 5,
    },
    {
      text: '6',
      value: 6,
    },
  ],
  badges: {
    reesults: [],
  },
}
